import { KanagawaThemeProvider } from '@aid/theme';
import { AuthProvider, useAuth } from './providers/KeycloakProvider';
import { LoginPage } from './LoginPage';
import { CatalogPage } from './CatalogPage';
import { LoadingScreen } from './components/LoadingScreen';

function HubContent() {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <CatalogPage />;
}

export function App() {
  return (
    <KanagawaThemeProvider>
      <AuthProvider>
        <HubContent />
      </AuthProvider>
    </KanagawaThemeProvider>
  );
}
